{
  "Incorrect username or password.": "メールアドレスまたはパスワードが正しくありません。",
  "Password attempts exceeded": "パスワードの試行回数が上限に達しました。しばらくしてから、もう一度お試しください。",
  "User does not exist.": "このメールアドレスのアカウントはありません。",
  "Username/client id combination not found.": "このメールアドレスのアカウントはありません。",
  "User is disabled.": "このアカウントは無効になっています。",
  "Attempt limit exceeded, please try after some time.": "試行回数が上限に達しました。しばらくしてから、もう一度お試しください。",
  "Invalid verification code provided, please try again.": "確認コードが正しくありません。もう一度お試しください。",
  "Invalid code provided, please request a code again.": "このコードは無効です。新しいコードをリクエストしてください。",
  "Password did not conform with policy: Password not long enough": "パスワードが短すぎます。",
  "Password does not conform to policy: Password not long enough": "パスワードが短すぎます。",
  "Cannot reset password for the user as there is no registered/verified email or phone_number": "確認済みのメールアドレスが登録されていないため、パスワードを再設定できません。",
  "A network error has occurred.": "ネットワークエラーが発生しました。もう一度お試しください。",
  "Open in EventLive App": "EventLiveアプリで開く",
  "Get EventLive App to go Live": "ライブ配信を開始するには、EventLiveアプリを入手してください",
  "Your {count} free service is ready": {
    "other": "無料の葬儀配信{count}件分をご用意しました"
  },
  "Welcome to EventLive, {name}": "{name}さん、EventLiveへようこそ",
  "Schedule a service to get a private link for the family — each service uses one credit. Want to practise first? Test streams are always free.": "葬儀の予定を設定すると、ご家族向けの非公開リンクが発行されます。葬儀1件につき1クレジットを使用します。先に練習したい場合は、テスト配信をいつでも無料でご利用いただけます。",
  "Your {count} free services appear here as credits within a minute of signing up. Not there? Message us and we'll add them.": "無料の葬儀配信{count}件分は、新規登録から1分以内にクレジットとしてここに表示されます。表示されない場合はメッセージでお知らせください。こちらで追加いたします。",
  "Schedule a service to get a private link for the family. Want to practise first? Test streams are always free.": "葬儀の予定を設定すると、ご家族向けの非公開リンクが発行されます。先に練習したい場合は、テスト配信をいつでも無料でご利用いただけます。",
  "Dismiss welcome": "ウェルカムメッセージを閉じる",
  "Thank you for your feedback! ": "ご意見ありがとうございます！",
  "Feel free to message us in chat with additional requests": "ほかにご要望があれば、チャットでお気軽にメッセージをお送りください",
  "How was your stream?": "配信はいかがでしたか？",
  "Please provide your feedback": "ご意見をお聞かせください",
  "Submit": "送信",
  "We’ll remind your guests before it starts.": "開始前に、ゲストへリマインダーをお送りします。",
  "DATE": "日付",
  "Other date": "別の日付",
  "START TIME": "開始時刻",
  "Select the start time": "開始時刻を選択",
  "Don’t have a date yet?": "日付がまだ決まっていませんか？",
  "Try a free test first": "まずは無料テストを試す",
  "Password Restore": "パスワードの再設定",
  "Enter the email associated with your account and we’ll send an email with instructions to restore your password": "アカウントに登録したメールアドレスを入力してください。パスワードを再設定する手順をメールでお送りします",
  "Send email": "メールを送信",
  "Check your mail": "メールをご確認ください",
  "We’ve sent you an email with a link to set a new password": "新しいパスワードを設定するためのリンクをメールでお送りしました",
  "Choose a New Password": "新しいパスワードを設定",
  "Your new password must be different from previous used passwords": "以前に使用したパスワードとは異なるパスワードを設定してください",
  "New Password": "新しいパスワード",
  "Set New Password": "新しいパスワードを保存",
  "Set up a live fundraiser for {name}": "{name}を支援する募金ライブ配信を設定",
  "Set up your live fundraiser": "募金ライブ配信を設定",
  "Welcome, {name}": "{name}さん、ようこそ",
  "Sign in to schedule your next service.": "ログインして、次の葬儀の予定を設定しましょう。",
  "Your first {count} services are free. No credit card needed.": "最初の{count}件の葬儀は無料です。クレジットカードは不要です。",
  "Create your account to schedule your first service.": "アカウントを作成して、最初の葬儀の予定を設定しましょう。",
  "Sign in to EventLive": "EventLiveにログイン",
  "Schedule ‘{title}’ and share the link": "「{title}」の予定を設定してリンクを共有",
  "Set up your account to try all the features and go live!": "アカウントを設定して、\nすべての機能を試し、\nライブ配信しましょう！",
  "Start your free test": "無料テストを開始",
  "Stream a test from your phone and watch it like a guest would. Schedule your event when you know the date.": "スマートフォンからテスト配信をして、ゲストと同じように視聴してみましょう。日付が決まったら、イベントの予定を設定してください。",
  "Invalid email": "メールアドレスが正しくありません",
  "Too Short!": "短すぎます",
  "Welcome back to EventLive": "EventLiveへおかえりなさい",
  "Create your password": "パスワードを作成",
  "Create a password for EventLive": "EventLiveのパスワードを作成",
  "Not your email?": "メールアドレスが違いますか？",
  "Your Password": "パスワード",
  "Choose Password": "パスワードを設定",
  "Sign In": "ログイン",
  "or": "または",
  "Your Email": "メールアドレス",
  "When is the wedding?": "結婚式はいつですか？",
  "When is the service?": "葬儀はいつですか？",
  "When is the party?": "パーティーはいつですか？",
  "When is the ceremony?": "式はいつですか？",
  "When is the game?": "試合はいつですか？",
  "When is your event?": "イベントはいつですか？",
  "Pick a date": "日付を選択",
  "Pick a start time": "開始時刻を選択",
  "That time has already passed": "その時刻はすでに過ぎています",
  "Congratulations! 🎉": "おめでとう\nございます！🎉",
  "Your wedding day is just a click away for your remote guests. It's almost\n      as perfect as being there": "遠く離れたゲストも、ワンクリックで結婚式に参加できます。\nまるでその場にいるかのような体験です",
  "Make it your own!": "自分らしくカスタマイズ！",
  "Replay and Download": "録画とダウンロード",
  "Your video is automatically saved in FULL HD resolution. Download it any time, and choose how long guests can watch the replay: 1 month, 1 year or 10 years.": "動画はフルHD画質で自動的に保存されます。いつでもダウンロードでき、ゲストが録画を視聴できる期間を1か月、1年、10年から選べます。",
  "Compared to the $500 we had been quoted from a live streamer who just sets up on camera, this app was far better and so much cheaper. Highly recommend.": "カメラを設置するだけのライブ配信業者からは$500の見積もりでしたが、このアプリのほうがはるかに良く、しかもずっと安く済みました。強くおすすめします。",
  "Bride review on the App Store": "App Storeでの新婦のレビュー",
  "Let's get started": "さっそく始めましょう",
  "Your event is just a click away for your remote guests. It's almost as perfect as being there": "遠く離れたゲストも、ワンクリックでイベントに参加できます。まるでその場にいるかのような体験です",
  "Customize everything": "すべてをカスタマイズ",
  "So simple and easy to use that I would recommend it for any of your live event needs. Weddings, ceremonies of any type, even a conference. This is a simple solution that lets you share the event happening in person with people anywhere. Setup and testing makes it easy to know what you need to do on the day of your event and their team is always standing by to help! Such a fantastic product - thank you!": "とてもシンプルで使いやすいので、どんなライブイベントにもおすすめです。結婚式、あらゆる種類のセレモニー、カンファレンスにも使えます。会場で行われているイベントを、どこにいる人とも共有できる手軽なソリューションです。事前の設定とテストのおかげで当日に何をすればいいかがよくわかり、しかもチームがいつでもサポートしてくれます！本当に素晴らしいサービスです。ありがとうございました！",
  "{author} on the App Store": "{author}（App Storeのレビュー）",
  "Our Condolences": "心よりお悔やみ申し上げます",
  "Give your family and friends the opportunity to say goodbye.": "ご家族やご友人に、お別れの機会をお届けしましょう。",
  "Personalize the Experience": "体験をパーソナライズ",
  "Share memories, photos, and messages to make the service more personal.": "思い出や写真、メッセージを共有して、より心のこもった式にしましょう。",
  "The service is automatically saved in FULL HD resolution. Download any time after and revisit the memories whenever you wish.": "式の様子はフルHD画質で自動的に保存されます。後からいつでもダウンロードして、好きなときに思い出を振り返ることができます。",
  "This worked flawlessly for livestream a celebration of life for my daughter. We had over 100 people on the day and many have watched on replay. It was easy to set up and I loved the fact that I could test it ahead of the actual event to build confidence that it would work.": "娘のお別れ会のライブ配信に使いましたが、まったく問題なく動作しました。当日は100人以上が視聴し、その後も多くの方が録画で見てくれています。設定も簡単で、本番前にテストしてうまくいくと確信できたのが本当にありがたかったです。",
  "{author}, review on the AppStore": "{author}（App Storeのレビュー）",
  "Happy Birthday! 🎂": "お誕生日おめでとうございます！🎂",
  "Celebrate your special day with friends and family, no matter where they are.": "大切な日を、どこにいる家族や友人とも一緒にお祝いしましょう。",
  "Make it a Blast!": "最高の一日に！",
  "Add your personal touch to the celebration with custom details": "細部までこだわって、お祝いにあなたらしさを加えましょう",
  "Your video is automatically saved in FULL HD resolution. Download any time after and relive the moments whenever you want.": "動画はフルHD画質で自動的に保存されます。後からいつでもダウンロードして、好きなときにその瞬間をもう一度楽しめます。",
  "Game On! 🏀": "試合開始！🏀",
  "Bring the excitement of the game to fans everywhere.": "試合の興奮を、世界中のファンに届けましょう。",
  "Personalize the experience": "体験をパーソナライズ",
  "The game is automatically saved in FULL HD resolution. Download any time after and relive the best moments whenever you want.": "試合はフルHD画質で自動的に保存されます。後からいつでもダウンロードして、名場面を好きなときに振り返れます。",
  " Greet affordable easy to use option for streaming an event": "イベント配信に最適な、手頃で使いやすいサービスです。",
  "Let's get started!  🎒": "さっそく始めましょう！🎒",
  "Go live in 5 minutes, and share it with those who matter.": "5分でライブ配信を始めて、大切な人たちと共有しましょう。",
  "Add links, upload documents, write a welcome message and much more to customize the event": "リンクの追加、ドキュメントのアップロード、ウェルカムメッセージの作成など、イベントを自由にカスタマイズできます",
  "The video is automatically saved in FULL HD resolution. Download any time after to revisit whenever you want.": "動画はフルHD画質で自動的に保存されます。後からいつでもダウンロードして、好きなときに見返せます。",
  "Just started using EventLive about a week ago and it has been incredible! It's so easy to use and full of features that is lacking in many other apps in this category. The price per live-stream is also very affordable. I evaluated 5 other live-stream platforms and this is by far the best.": "1週間ほど前にEventLiveを使い始めましたが、本当に素晴らしいです！とても使いやすく、同じジャンルの多くのアプリにはない機能が充実しています。ライブ配信1回あたりの料金もとても手頃です。ほかに5つのライブ配信プラットフォームを比較しましたが、これが断トツで一番です。",
  "Please enter number of days": "日数を入力してください",
  "At least 1 day": "1日以上を指定してください",
  "7 days max": "最大7日間",
  "Your all‑in‑one event live streaming app": "イベントの\nライブ配信は\nこれひとつで",
  "24,000+ events streamed": "24,000件以上のイベントを配信",
  "1000+ reviews worldwide": "世界中で1000件以上のレビュー",
  "A personal event": "個人のイベント",
  "Events for my business": "ビジネスのイベント",
  "I want to attend an event": "イベントに参加したい",
  "Which role describes you best?": "あなたに最も当てはまる役割はどれですか？",
  "What kind of event would you like to stream?": "どのようなイベントを配信しますか？",
  "Title of Your Event": "イベントのタイトル",
  "Event Title *": "イベントのタイトル *",
  "We've noticed \"test\" in your event title.": "テスト用のイベントのようです。",
  "Don't have an event scheduled yet? No problem.": "まだイベントの予定がありませんか？大丈夫です。",
  "Your Event Page Link": "イベントページのリンク",
  "Your event link is all you need to invite the guests. Text it, email it, print on your invitations.": "ゲストを招待するには、イベントリンクがあれば十分です。メッセージやメールで送ったり、招待状に印刷したりできます。",
  "your-event-link": "my-event",
  "Your link is available!": "このリンクは使用できます！",
  "Only english letters, numbers, dashes and underscore allowed.": "使用できるのは半角英数字、ハイフン（-）、アンダースコア（_）のみです。",
  "Sorry, this link is taken. Try adding a few characters": "申し訳ありません。このリンクはすでに使用されています。文字をいくつか追加してみてください",
  "Personalize your event pages": "イベントページを\nカスタマイズ",
  "Company Name": "会社名",
  "Website (optional)": "ウェブサイト（任意）",
  "You can upload your logo in profile settings": "ロゴはプロフィール設定でアップロードできます",
  "Creating '{title}' event": "イベント「{title}」を作成しています",
  "Link must be non-empty and can only contain letters, numbers, dashes and underscores. ": "リンクを入力してください。使用できるのは半角英数字、ハイフン（-）、アンダースコア（_）のみです。",
  "Please choose another one.": "別のリンクを選択してください。",
  "Sorry, this link is taken. ": "申し訳ありません。このリンクはすでに使用されています。",
  "What would you like to live stream, {name}?": "{name}さん、何をライブ配信しますか？",
  "What would you like to live stream?": "何をライブ配信しますか？",
  "I already have an account": "すでにアカウントをお持ちの方",
  "Too Long!": "長すぎます",
  "Please enter your full name": "氏名を入力してください",
  "Please enter a valid email": "有効なメールアドレスを入力してください",
  "Password is too short": "パスワードが短すぎます",
  "Password is required": "パスワードを入力してください",
  "50 characters at most": "50文字以内で入力してください",
  "Enter your first name": "名を入力してください",
  "Enter an email address like name@example.com": "name@example.comのような形式でメールアドレスを入力してください",
  "Enter your email": "メールアドレスを入力してください",
  "Title is Required": "タイトルを入力してください",
  "Timezone needs to be detected": "タイムゾーンを検出する必要があります",
  "Please choose your custom event link": "イベントのカスタムリンクを選択してください",
  "Sorry, Already Taken": "申し訳ありません。すでに使用されています",
  "Only letters, numbers, dashes and underscore allowed.": "使用できるのは半角英数字、ハイフン（-）、アンダースコア（_）のみです。",
  "Add a title": "タイトルを入力してください",
  "Choose the date and time": "日時を選択してください",
  "Choose a link for your event": "イベントのリンクを選択してください",
  "Use only letters, numbers, dashes and underscores.": "半角英数字、ハイフン（-）、アンダースコア（_）のみを使用してください。",
  "That link is taken. Try another.": "このリンクはすでに使用されています。別のリンクをお試しください。",
  "Link URL is required": "リンクのURLを入力してください",
  "Title is required": "タイトルを入力してください",
  "Invalid format. It should be in the format of price_(letters_and_digits)": "形式が正しくありません。「price_(英数字)」の形式で入力してください",
  "Please use HH:MM:SS format": "HH:MM:SSの形式で入力してください",
  "Please add Guest's name": "ゲストの名前を入力してください",
  "Not a valid Email": "メールアドレスが正しくありません",
  "Add guest's email to invite": "招待するゲストのメールアドレスを入力してください",
  "Enter the message": "メッセージを入力してください",
  "Forgot password?": "パスワードをお忘れですか？",
  "Continue with Apple": "Appleで続ける",
  "Sign In Cancelled": "ログインがキャンセルされました",
  "Sign In with Google Unavailable": "Googleでのログインは利用できません",
  "Sign In Error, please try using a different method": "ログインエラーです。別の方法をお試しください",
  "Continue with Google": "Googleで続ける",
  "By continuing you agree to our <privacy>privacy policy</privacy> and <terms>terms</terms>": "続行すると、<privacy>プライバシーポリシー</privacy>と<terms>利用規約</terms>に同意したものとみなされます",
  "No logo yet": "ロゴはまだありません",
  "Change logo": "ロゴを変更",
  "Upload logo": "ロゴをアップロード",
  "Email changed": "メールアドレスを変更しました",
  "Sign in with {email} from now on.": "今後は{email}でログインしてください。",
  "Another EventLive account already uses this email.": "このメールアドレスは、すでに別のEventLiveアカウントで使用されています。",
  "Couldn't change the email. Try again.": "メールアドレスを変更できませんでした。もう一度お試しください。",
  "Change email": "メールアドレスを変更",
  "Change your sign-in email?": "ログイン用のメールアドレスを変更しますか？",
  "You'll sign in with {email} from now on. The change is immediate, with no confirmation email, so check the address.": "今後は{email}でログインすることになります。変更はすぐに反映され、確認メールは送信されないため、アドレスに誤りがないかご確認ください。",
  "Sign-in email": "ログイン用メールアドレス",
  "you@example.com": "name@example.com",
  "Your details": "基本情報",
  "First name": "名",
  "Last name": "姓",
  "Account type": "アカウントの種類",
  "Personal": "個人",
  "Your own events, like a wedding, birthday or memorial.": "結婚式、誕生日、お別れ会など、ご自身のイベント。",
  "Business": "ビジネス",
  "Events for clients or your organization, with your branding and a Video Wall.": "クライアントや所属団体のためのイベント。ブランディングとビデオウォールを利用できます。",
  "What best describes you?": "あなたに最も当てはまるものは？",
  "Your role": "あなたの役割",
  "e.g. Sports club": "例：スポーツクラブ",
  "Event page branding": "イベントページのブランディング",
  "Your logo or company name at the top of all your event pages.": "すべてのイベントページの上部に、ロゴまたは会社名が表示されます。",
  "Company name": "会社名",
  "e.g. Anna & Mark Weddings": "例：山田ウェディングフォト",
  "Shown when you haven't uploaded a logo.": "ロゴをアップロードしていない場合に表示されます。",
  "Website": "ウェブサイト",
  "e.g. annaandmark.com": "例：yamada-wedding.jp",
  "Your logo or company name links to it.": "ロゴまたは会社名から、このウェブサイトにリンクします。",
  "PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best.": "PNGまたはJPG形式で、余白の切り取りとサイズ調整は自動で行われます。横長のロゴがおすすめです。",
  "Remove all branding": "ブランディングをすべて非表示",
  "No logo, company name or EventLive logo at the top of your event pages.": "イベントページの上部に、ロゴ、会社名、EventLiveのロゴを表示しません。",
  "Just the most amazing app. Did exactly what we wanted it too, with incredible quality.": "本当に最高のアプリです。期待していたとおりのことを、驚くほどの高画質で実現してくれました。",
  "I absolutely loved having this live stream service for my wedding. It was clear and my guests enjoyed watching our ceremony from afar.": "結婚式にこのライブ配信サービスを使えて、本当によかったです。映像も鮮明で、遠方のゲストも私たちの挙式を楽しんで見てくれました。",
  "Stellar app, easy to use, very intuitive. I would highly recommend it, less complicated than Facebook and youtube especially from the viewer’s perspective (single click and you are there). Worth every penny, one has enough to worry about without the stress of overly complicated streaming apps.": "素晴らしいアプリです。使いやすく、とても直感的です。特に視聴する側にとっては、FacebookやYouTubeよりもずっとシンプルなので（ワンクリックで視聴できます）、強くおすすめします。払った金額以上の価値があります。ただでさえ心配事が多いときに、複雑すぎる配信アプリでストレスを抱える必要はありません。",
  "By far the easiest to use. I could live stream my event with such ease! And it recorded it and it let the guests leave messages.": "断トツで使いやすいです。イベントのライブ配信がとても簡単にできました！しかも録画もしてくれて、ゲストがメッセージを残すこともできました。",
  "Easy to use, not crazy expensive, great connection and image. Our family and friends loved it!": "使いやすく、値段も高すぎず、接続も映像も素晴らしかったです。家族や友人にも大好評でした！",
  "Great affordable easy to use option for streaming an event.": "イベント配信に最適な、手頃で使いやすいサービスです。",
  "The platform was exactly what we were looking for. It’s easy to use & very affordable. I love that it does not limit the number of viewers that can join in.": "まさに探していたとおりのプラットフォームでした。使いやすく、料金もとても手頃です。参加できる視聴者数に制限がないのも気に入っています。",
  "This was so easy to use and share. I looked at so many other platforms and they were so complicated. None of our guests had any issue. Highly recommend!!": "とても簡単に使えて、共有も簡単でした。ほかにもたくさんのプラットフォームを見ましたが、どれもとても複雑でした。ゲストも誰一人困ることはありませんでした。強くおすすめします！！",
  "This app is so easy to use. I’m a 74 year old curmudgeon and I can use it. Plus when I screw up their support helps me fix it. Really I am so happy I was introduced to it.": "このアプリは本当に使いやすいです。74歳の頑固者の私でも使えます。しかも、私が失敗したときは、サポートの方が直すのを手伝ってくれます。このアプリを紹介してもらえて、本当によかったです。",
  "This was the best decision we made! The ability to livestream for family and friends that could not attend was invaluable!!": "最高の決断でした！参列できなかった家族や友人のためにライブ配信できたことは、何物にも代えがたいものでした！！",
  "If I could give this app ten stars I would!": "このアプリに星を10個付けられるなら、そうしたいくらいです！",
  "Extremely delighted with the service. This is a no nonsense app. You get to test and then you purchase and off you go!": "サービスにとても満足しています。無駄のないアプリです。テストしてから購入すれば、あとは配信するだけです！",
  "EventLive exceeded our expectations! So if you are thinking about using them JUST DO IT!!! The video and sound quality was excellent!": "EventLiveは期待以上でした！利用を迷っているなら、迷わず使ってください！！！映像も音質も最高でした！"
}
